import { buildTranslate } from 'locales'
import type { Fields as Campaign } from 'models/Campaign'
import React from 'react'
import Helmet from 'react-helmet'
import MessagingEditor from './components/MessagingEditor'

type Props = {
  campaign: Campaign
  setSubstep?: (step: string) => void
  disableButton?: boolean
  disableRedeem?: boolean
  customButtonToggleGroup?: React.ReactNode
  canProceed: boolean
  showValidationErrors?: () => void
}

const t = buildTranslate('thanx_campaigns.builder.forms.messaging_tabs')

const Messaging: React.FC<Props> = props => {
  return (
    <>
      <Helmet>
        <title>{t('page_title')}</title>
      </Helmet>
      <MessagingEditor {...props} />
    </>
  )
}

export default Messaging
